// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let DialogV5 = require("../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let InlineWarning__Jsx3 = require("../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let ShareDraftFormRelay = require("./ShareDraftFormRelay.bs.js");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let ShareDraftFormConfigRelay = require("./ShareDraftFormConfigRelay.bs.js");
let ShareDraftModalQuery_graphql = require("../../__generated__/ShareDraftModalQuery_graphql.bs.js");
let ShareDraftModal_ShareDraftMutation_graphql = require("../../__generated__/ShareDraftModal_ShareDraftMutation_graphql.bs.js");
let ShareDraftModalSharedRecipientsList_contacts_graphql = require("../../__generated__/ShareDraftModalSharedRecipientsList_contacts_graphql.bs.js");

let convertVariables = ShareDraftModalQuery_graphql.Internal.convertVariables;

let convertResponse = ShareDraftModalQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = ShareDraftModalQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, ShareDraftModalQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, ShareDraftModalQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(ShareDraftModalQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(ShareDraftModalQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(ShareDraftModalQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(ShareDraftModalQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

let convertVariables$1 = ShareDraftModal_ShareDraftMutation_graphql.Internal.convertVariables;

let convertResponse$1 = ShareDraftModal_ShareDraftMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = ShareDraftModal_ShareDraftMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, ShareDraftModal_ShareDraftMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, ShareDraftModal_ShareDraftMutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let ShareDraftMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$1
};

let convertFragment = ShareDraftModalSharedRecipientsList_contacts_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ShareDraftModalSharedRecipientsList_contacts_graphql.node, convertFragment, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ShareDraftModalSharedRecipientsList_contacts_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(fRef) : undefined, ShareDraftModalSharedRecipientsList_contacts_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ShareDraftModalSharedRecipientsList_contacts_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$2,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ShareDraftModal$SharedRecipientsList(props) {
  let contacts = RescriptRelay_Fragment.useFragment(ShareDraftModalSharedRecipientsList_contacts_graphql.node, convertFragment, props.contacts);
  if (contacts.length !== 0) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("div", {
          children: "Already shared with",
          className: "text-xs uppercase tracking-wide text-gray-500"
        }),
        JsxRuntime.jsx("ul", {
          children: contacts.map(contact => {
            let tmp;
            switch (contact.__typename) {
              case "SharingContactClientContactV5" :
                let firstName = contact.firstName;
                tmp = firstName !== undefined ? JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("strong", {
                        children: firstName + ` ` + Stdlib_Option.getOr(contact.lastName, "")
                      }),
                      JsxRuntime.jsx("div", {
                        children: Stdlib_Option.getOr(Stdlib_Option.map(contact.email, e => Scalars.EmailAddress.toString(e)), "")
                      })
                    ]
                  }) : null;
                break;
              case "SharingContactFreshContactV5" :
                let email = contact.email;
                tmp = email !== undefined ? Scalars.EmailAddress.toString(Primitive_option.valFromOption(email)) : null;
                break;
              case "__unselected" :
                tmp = null;
                break;
            }
            let tmp$1;
            switch (contact.__typename) {
              case "SharingContactClientContactV5" :
              case "SharingContactFreshContactV5" :
                tmp$1 = contact.databaseId;
                break;
              case "__unselected" :
                tmp$1 = contact._0;
                break;
            }
            return JsxRuntime.jsx("li", {
              children: tmp,
              className: "text-gray-700"
            }, tmp$1);
          }),
          className: "mt-3 space-y-4"
        })
      ],
      className: "rounded-md border border-gray-200 bg-gray-50 p-4"
    });
  } else {
    return null;
  }
}

let SharedRecipientsList = {
  Fragment: Fragment,
  make: ShareDraftModal$SharedRecipientsList
};

function ShareDraftModal$ModalContent(props) {
  let draftId = props.draftId;
  let data = usePreloaded(props.queryRef);
  let match = use$1();
  let mutate = match[0];
  let sharedWithContactsRefs = Stdlib_Option.getOr(Stdlib_Option.flatMap(data.draftV5, result => {
    if (result.__typename === "DraftV5") {
      return result.sharedWithContacts;
    }
  }), []).map(contact => contact.fragmentRefs);
  let agentDisplayName = Stdlib_Option.map(data.currentlyLoggedInAgent, agent => agent.displayName);
  let propertyLabel;
  propertyLabel = props.propertyType === "FOR_SALE" ? "property" : "rental property";
  let subject = agentDisplayName !== undefined ? agentDisplayName + " shared a Top Agent Network " + propertyLabel + " draft with you" : "A Top Agent Network " + propertyLabel + " draft was shared with you";
  let form = ShareDraftFormConfigRelay.useForm({
    contacts: [],
    subject: subject,
    message: undefined
  }, (state, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    mutate({
      input: {
        contacts: state.contacts.map(c => {
          if (c.TAG === "Contact") {
            return {
              id: c.id
            };
          } else {
            return {
              email: c.email
            };
          }
        }),
        draftId: draftId,
        message: state.message,
        subject: state.subject
      }
    }, undefined, undefined, undefined, (response, _mutationErrors) => {
      let match = response.sharePropertyDraftV5;
      if (match !== undefined && match.__typename === "SharedDraftV5") {
        return notifyOnSuccess({
          contacts: [],
          subject: state.subject,
          message: state.message
        });
      } else {
        return notifyOnFailure("Failed to share draft. Please contact support or try again later.");
      }
    }, param => notifyOnFailure("Failed to share draft. Please contact support or try again later."), undefined);
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(ShareDraftModal$SharedRecipientsList, {
        contacts: sharedWithContactsRefs
      }),
      JsxRuntime.jsx(ShareDraftFormRelay.make, {
        onSubmit: () => form.submit(),
        onCancel: props.onDismiss,
        form: form
      })
    ],
    className: "space-y-8"
  });
}

let ModalContent = {
  make: ShareDraftModal$ModalContent
};

function ShareDraftModal(props) {
  let draftId = props.draftId;
  let onDismiss = props.onDismiss;
  let isOpen = props.isOpen;
  let match = useLoader();
  let disposeQuery = match[2];
  let loadQuery = match[1];
  let queryRef = match[0];
  React.useEffect(() => {
    if (isOpen && draftId !== undefined) {
      loadQuery({
        draftId: draftId
      }, "network-only", undefined);
    }
    if (!isOpen) {
      disposeQuery();
    }
  }, [
    isOpen,
    draftId
  ]);
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Share Draft",
    isOpen: isOpen,
    ariaLabel: "Share Draft",
    onDismiss: onDismiss,
    size: "XXLarge",
    showCloseButton: true,
    children: draftId !== undefined ? (
        queryRef !== undefined ? JsxRuntime.jsx(React.Suspense, {
            children: JsxRuntime.jsx(FragmentErrorBoundary.make, {
              fragmentDisplayName: "share draft modal",
              children: JsxRuntime.jsx(ShareDraftModal$ModalContent, {
                queryRef: Primitive_option.valFromOption(queryRef),
                draftId: draftId,
                propertyType: props.propertyType,
                onDismiss: onDismiss
              })
            }),
            fallback: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Loader.make, {}),
              className: "mt-4"
            })
          }) : JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(Loader.make, {}),
            className: "mt-4"
          })
      ) : JsxRuntime.jsx(InlineWarning__Jsx3.make, {
        children: "This draft hasn't been saved yet. Please wait for it to finish saving."
      })
  });
}

let make = ShareDraftModal;

exports.Query = Query;
exports.ShareDraftMutation = ShareDraftMutation;
exports.SharedRecipientsList = SharedRecipientsList;
exports.ModalContent = ModalContent;
exports.make = make;
/* use Not a pure module */
